import chevronLeft from '../../../images/svg/chevron-left.svg';
import chevronLeftRebrand from '../../../images/rebrand/svg/chevron-left.svg';
import { Image, Text } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

var MissingCreditHeader = function MissingCreditHeader(props) {
  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model,
      receiptScreens = props.receiptScreens,
      handleShowMissingCreditScreen = props.handleShowMissingCreditScreen,
      setShowMissCreditInfo = props.setShowMissCreditInfo;
  var flags = useFlags();
  var useNewRebrandStyles = flags['releaseRebrandDstr6457'] || false;
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-account-miss-credit__header"
  }, /*#__PURE__*/React.createElement("a", {
    href: "#",
    className: "cb-account-miss-credit__back",
    onClick: function onClick(e) {
      e.preventDefault();

      if (receiptScreens) {
        handleShowMissingCreditScreen();
      } else {
        setShowMissCreditInfo(false);
      }
    }
  }, /*#__PURE__*/React.createElement("img", {
    className: "cb-account-miss-credit__back-icon",
    src: useNewRebrandStyles ? chevronLeftRebrand : chevronLeft,
    alt: 'Chevron Left'
  })), /*#__PURE__*/React.createElement("div", {
    className: 'cb-account-miss-credit__header__title'
  }, /*#__PURE__*/React.createElement(Text, {
    className: 'cb-account-miss-credit__module-title',
    tag: 'span',
    field: model.ModuleTitle
  }), /*#__PURE__*/React.createElement("div", {
    className: "cb-account-miss-credit__logo ".concat(receiptScreens ? 'cb-account-miss-credit__logo--receipt-screens' : '')
  }, /*#__PURE__*/React.createElement(Image, {
    field: model.Image
  }))));
};

export default MissingCreditHeader;